import React from 'react';
import ClassNames from 'classnames';

var InlineError = React.createClass({
    render: function () {
        let markup = '';
        if (this.props.useHtml) {
            var html = { __html: this.props.message };
            markup = <p dangerouslySetInnerHTML={html}></p>;
        }
        else {
            markup = <p>{this.props.message}</p>;
        }
        return (
                <div key={this.props.key} id={this.props.className} className={ClassNames(this.props.className, { hidden: this.props.isHideError })}>
                    <h5>{this.props.header}</h5>
                    {markup}
                </div>
        );
    }
});

module.exports = InlineError;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/InlineError.jsx